const postConfig = [
    {
      title: "News & Events",
      data: [],
    },
    {
      title: "Articles",
      data: [],
    },
    {
      title: "Videos",
      data: []
    }
  ];
  export default postConfig